import { createJSONStorage } from 'zustand/middleware'

/**
 * Persisted store state is a cross-session convenience, never required for the
 * current session. Safari can throw QuotaExceededError on write or SecurityError
 * on any access (blocked cookies, private browsing); Zustand's persist calls
 * setItem synchronously inside set(), so an uncaught throw would crash whatever
 * component triggered the update.
 */
export const safeLocalStorage = createJSONStorage(() => ({
  getItem: (name) => {
    try {
      return localStorage.getItem(name)
    } catch {
      return null
    }
  },
  setItem: (name, value) => {
    try {
      localStorage.setItem(name, value)
    } catch {
      // Best-effort persistence; the in-memory state is already updated.
    }
  },
  removeItem: (name) => {
    try {
      localStorage.removeItem(name)
    } catch {
      // Best-effort persistence; nothing to recover.
    }
  },
}))
